/**
 * Cross-Sell Menu (assets/cross-sell-menu.js)
 * Implements sticky tabs, smooth scrollspy, live search filter, and 1-click add-on cart.
 */
(function() {
  'use strict';

  function initCrossSellMenu() {
    var menus = document.querySelectorAll('.csm-wrapper');
    if (!menus.length) return;

    menus.forEach(function(menu) {
      if (menu.dataset.csmInit === '1') return;
      menu.dataset.csmInit = '1';

      var navBar = menu.querySelector('.csm-nav-bar');
      var tabsTrack = menu.querySelector('.csm-tabs-track');
      var tabBtns = menu.querySelectorAll('.csm-tab-btn');
      var prevArrow = menu.querySelector('.csm-arrow--prev');
      var nextArrow = menu.querySelector('.csm-arrow--next');
      var searchInput = menu.querySelector('.csm-search-input');
      var searchClear = menu.querySelector('.csm-search-clear');
      var sections = menu.querySelectorAll('.csm-collection-section');
      var allCards = menu.querySelectorAll('.csm-product-card');
      var noResults = menu.querySelector('.csm-no-results');

      // ─── 1. Arrow Navigation for Tabs Track ───────────────────────────────
      function updateArrowState() {
        if (!tabsTrack) return;
        var maxScroll = tabsTrack.scrollWidth - tabsTrack.clientWidth;
        if (prevArrow) prevArrow.disabled = tabsTrack.scrollLeft <= 5;
        if (nextArrow) nextArrow.disabled = tabsTrack.scrollLeft >= maxScroll - 5;
      }

      if (tabsTrack) {
        tabsTrack.addEventListener('scroll', updateArrowState, { passive: true });
        updateArrowState();

        if (prevArrow) {
          prevArrow.addEventListener('click', function() {
            tabsTrack.scrollBy({ left: -220, behavior: 'smooth' });
          });
        }
        if (nextArrow) {
          nextArrow.addEventListener('click', function() {
            tabsTrack.scrollBy({ left: 220, behavior: 'smooth' });
          });
        }
      }

      // ─── 2. Smooth Scroll on Tab Click ────────────────────────────────────
      function scrollToSection(targetId) {
        var targetEl = document.getElementById(targetId);
        if (!targetEl) return;

        // Compute sticky offset
        var navHeight = navBar ? navBar.offsetHeight : 50;
        var siteHeader = document.querySelector('.site-header') || document.querySelector('.header-wrap');
        var siteHeaderHeight = (siteHeader && window.getComputedStyle(siteHeader).position === 'fixed')
          ? siteHeader.offsetHeight
          : 0;

        var targetTop = targetEl.getBoundingClientRect().top + window.pageYOffset - (navHeight + siteHeaderHeight + 10);

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth'
        });
      }

      function setActiveTab(targetId) {
        tabBtns.forEach(function(btn) {
          var isActive = btn.dataset.target === targetId;
          btn.classList.toggle('is-active', isActive);

          // Scroll active tab into view in tabs track
          if (isActive && tabsTrack) {
            var btnLeft = btn.offsetLeft;
            var btnWidth = btn.offsetWidth;
            var trackWidth = tabsTrack.clientWidth;
            var currentScroll = tabsTrack.scrollLeft;

            if (btnLeft < currentScroll || (btnLeft + btnWidth) > (currentScroll + trackWidth)) {
              tabsTrack.scrollTo({
                left: btnLeft - (trackWidth / 2) + (btnWidth / 2),
                behavior: 'smooth'
              });
            }
          }
        });
      }

      tabBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var targetId = btn.dataset.target;
          setActiveTab(targetId);
          scrollToSection(targetId);
        });
      });

      // ─── 3. Scrollspy (Highlight Tab & Sticky Bar Shadow) ─────────────────
      function onScroll() {
        var scrollPos = window.pageYOffset;
        var navHeight = navBar ? navBar.offsetHeight : 50;
        var siteHeader = document.querySelector('.site-header') || document.querySelector('.header-wrap');
        var siteHeaderHeight = (siteHeader && window.getComputedStyle(siteHeader).position === 'fixed')
          ? siteHeader.offsetHeight
          : 0;

        var checkOffset = scrollPos + navHeight + siteHeaderHeight + 80;

        // Toggle sticky shadow
        if (navBar) {
          var menuTop = menu.getBoundingClientRect().top + scrollPos;
          navBar.classList.toggle('is-stuck', scrollPos >= menuTop);
        }

        // Find active section
        var currentSectionId = null;
        sections.forEach(function(sec) {
          if (sec.style.display === 'none') return;
          var secTop = sec.offsetTop;
          var secHeight = sec.offsetHeight;
          if (checkOffset >= secTop && checkOffset < (secTop + secHeight + 30)) {
            currentSectionId = sec.id;
          }
        });

        if (currentSectionId) {
          tabBtns.forEach(function(btn) {
            btn.classList.toggle('is-active', btn.dataset.target === currentSectionId);
          });
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });

      // ─── 4. Live Search Filter ────────────────────────────────────────────
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          var query = searchInput.value.trim().toLowerCase();

          if (searchClear) {
            searchClear.classList.toggle('hide', query.length === 0);
          }

          var totalVisible = 0;

          sections.forEach(function(sec) {
            var cards = sec.querySelectorAll('.csm-product-card');
            var secVisible = 0;

            cards.forEach(function(card) {
              if (!query) {
                card.style.display = '';
                secVisible++;
                totalVisible++;
                return;
              }

              var title = card.dataset.title || '';
              var desc = card.dataset.desc || '';
              var category = card.dataset.category || '';

              if (title.indexOf(query) !== -1 || desc.indexOf(query) !== -1 || category.indexOf(query) !== -1) {
                card.style.display = '';
                secVisible++;
                totalVisible++;
              } else {
                card.style.display = 'none';
              }
            });

            // Hide whole collection section if 0 visible cards
            sec.style.display = secVisible > 0 ? '' : 'none';
          });

          if (noResults) {
            noResults.style.display = totalVisible === 0 ? 'block' : 'none';
            if (totalVisible === 0) {
              var querySpan = noResults.querySelector('.js-csm-query');
              if (querySpan) querySpan.textContent = query;
            }
          }
        });

        if (searchClear) {
          searchClear.addEventListener('click', function() {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input'));
            searchInput.focus();
          });
        }
      }

      // ─── 5. 1-Click Quick Add to Cart ─────────────────────────────────────
      menu.addEventListener('click', function(e) {
        var addBtn = e.target.closest('.js-csm-quick-add');
        if (!addBtn) return;

        e.preventDefault();
        e.stopPropagation();

        var variantId = addBtn.dataset.variantId;
        var productTitle = addBtn.dataset.title || 'Prodotto';
        if (!variantId) return;

        // Button loading state
        addBtn.classList.add('is-loading');
        addBtn.innerHTML = '<div class="csm-btn-spinner"></div>';
        addBtn.disabled = true;

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: 1,
                properties: {
                  'Extra': 'Aggiunto da Menu Cross-sell'
                }
              }
            ]
          })
        })
        .then(function(res) {
          if (!res.ok) {
            return res.json().then(function(err) { throw err; });
          }
          return res.json();
        })
        .then(function(item) {
          // Success state
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          addBtn.innerHTML = '✓';

          // Update mini cart drawer
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.updateElements();
            window.theme.miniCart.generateCart();
          }

          // If cart drawer enabled, open it or show notification
          var styleCart = window.jQuery ? window.jQuery('.js-mini-cart').attr('data-cartmini') : null;
          if (styleCart === 'true') {
            if (window.jQuery) window.jQuery('.js-mini-cart').addClass('active');
          } else if (window.theme && window.theme.alert) {
            var htmlAlert = '<div class="media mt-2 alert--cart">' +
              '<div class="media-body align-self-center">' +
              '<p class="m-0 font-weight-bold">' + productTitle + ' x 1</p>' +
              '<div class="small text-muted font-italic">Aggiunto al tuo ordine!</div>' +
              '</div></div>';
            window.theme.alert.new(
              (window.theme.strings && window.theme.strings.addToCartSuccess) || 'Aggiunto al carrello!',
              htmlAlert,
              3000,
              'notice'
            );
          }

          // Revert button after 1.8 seconds
          setTimeout(function() {
            addBtn.classList.remove('is-added');
            addBtn.innerHTML = '+';
            addBtn.disabled = false;
          }, 1800);
        })
        .catch(function(err) {
          console.error('Error adding cross-sell item to cart:', err);
          addBtn.classList.remove('is-loading');
          addBtn.innerHTML = '+';
          addBtn.disabled = false;

          var msg = (err && (err.description || err.message)) || 'Impossibile aggiungere il prodotto al carrello.';
          if (window.theme && window.theme.alert) {
            window.theme.alert.new('', msg, 3000, 'warning');
          } else {
            alert(msg);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrossSellMenu);
  } else {
    initCrossSellMenu();
  }
  document.addEventListener('shopify:section:load', initCrossSellMenu);
})();

